import { z } from "zod"

export const loginSchema = z.object({
  email: z.string().email(),
  password: z.string().min(1),
})

export type LoginInput = z.infer<typeof loginSchema>

export const loginWithIdTokenSchema = z.object({
  idToken: z.string().min(1),
})

export type LoginWithIdTokenInput = z.infer<typeof loginWithIdTokenSchema>
